import React from 'react'
import { motion } from 'framer-motion'

export const Banner = () => {
  return (
    <div style={{ marginBottom: '30px', overflow: 'hidden' }}>
      <motion.picture
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 2 }}
        style={{
          position: 'relative',
          width: '100%',
          height: '700px',
          display: 'block',
          overflow: 'hidden',
        }}
      >
        <source
          srcSet="/main-img/main-banner.webp"
          type="image/webp"
          media="(min-width: 1401px)"
        />
        <source
          srcSet="/main-img/main-banner-1400.webp"
          type="image/webp"
          media="(max-width: 1400px)"
        />
        <source
          srcSet="/main-img/main-banner-700.webp"
          type="image/webp"
          media="(max-width: 700px)"
        />
        <motion.img
          src="/main-img/main-banner.jpg"
          alt="container"
          loading="eager"
          style={{
            objectFit: 'cover',
            objectPosition: 'center',
            width: '100%',
            height: '700px',
          }}
        />
      </motion.picture>

      <div id="banner-text-wrapper">
        <div
          id="h0"
          initial={{ x: '100px', opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          Seojin Logitech
        </div>
        <motion.div
          id="banner-text"
          initial={{ x: '100px', opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1.1, delay: 0.3 }}
        >
          정직과 정도 경영으로
          <br />
          고객의 신뢰를 얻겠습니다.
        </motion.div>
      </div>
    </div>
  )
}
